var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Ktmlogo from '../../../assets/images/KTMLogo.png';
import BajajLogo from '../../../assets/images/BajajLogo.png';
import TriumphLogo from '../../../assets/images/TriumphLogo.png';
import { Config } from '../../../api/config';
var logoMap = {
    MC: BajajLogo,
    CV: BajajLogo,
    PB: Ktmlogo,
    Triumph: TriumphLogo
};
export var brandLogoBase64 = "";
export var scissorImageBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHYSURBVHgB7ZnvbcIwEMWfOgEjeISOcCOwAR6hG9ANyAawCWxAN4BOwAiprRCRnp34kji2kfKT7kPV2HnPPv/JAaysrIQgE5WJm4n6GVcTRxMKBbMxccBLdF8cns8WhRVkR7kWxhWFmZCMvG8mikDBFWfzn/Aa5S3+r4k2CAVwgivelx4buCYqFADP/e3AswTXbHZ4WgyxGfl8Erig0O6ypAH77r2JB5rZ3Uka3SFfmFu422kMusK7/T8kjStMX8RHzKNP+Kg1Rj0NdeclBP82qjCNkPB29LW0wwrjD7KpW+iXQPg3Rp70Ka4SGv5ZnCWcm5DMxBnjXqKXFs5RcE9nHkeE81+nFs5RmGaEcguHR9AFYSP2jDgjvPCzXcMJYSNzUi4ZBLmR6MI/EIcabwghnONFphAhLPyC5oS9oSAjJBROrJ1GZiM0UThHI7ERaV3ojLhXiShGSrjM2f/tMdFIyrqQRmQjqqcTwrJ1IY2wkZ2ko5OnYcq6kEa/EdE3cSl1IQ3XiKh/7nqIpetCCs1V2woXfxNzQTnrQkF8l7lf9vcn+uHp9YMCyFkXigLBv4W1o71EXSg6KetCi/D2PzFZpHWhrB/mEhSa09nuMK3oOxrhhJWVlaz8AXN0E6PKxeeRAAAAAElFTkSuQmCC';
export var scissorRightImageBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEMSURBVHgB3ZRdEcIwEIQXFOCA4gAJ5wAcECfEATgAFAAKiBNAARLgSi9DCC3NtXnqN7Nz0+vPJunOAUNjhDwQa8UqWDfWgeWQmTXrWaM1MkLBh61cb4MeIRN7+eAm6lvp73xjHNwsWEvomEo9R30ndVZnVG75yLqyDNK4S6Wov5B6rXtpLjf8+aYYUvD8Rq7DcNC/l43S0KI+dRaJmATDCX7j7dAxbabBsDR45DBoM1QZjNGfMuIFMmDwvROHagdx/4KM/4Yannt0MSTo4h2nrnWozmU1qQZ+UeqhelIYePZIHKohhcLA40+Aoj7hE5w3YbxvskINnYZqFwg9hqoWi55DVQOhOnYnlTB4XreMijkKIkayAAAAAElFTkSuQmCC';
export var OrganizationAddressAPIURL = "".concat(Config.baseURL, "OrganizationAddress/AddressByOrganizationId");
export var getInstallbaseContractURL = "".concat(Config.baseURL, "InstallBaseContract/getInstallbaseContract");
export var numberToWords = function (num) {
    var a = ["", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE", "TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN"];
    var b = ["", "", "TWENTY", "THIRTY", "FORTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"];
    var units = ["", "THOUSAND", "MILLION", "BILLION"];
    if (num === 0)
        return "ZERO";
    var convertHundreds = function (n) {
        if (n < 20)
            return a[n];
        if (n < 100)
            return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        return a[Math.floor(n / 100)] + " HUNDRED" + (n % 100 ? " " + convertHundreds(n % 100) : "");
    };
    var numStr = num.toFixed(2).toString(); // Convert to string with 2 decimal places
    var _a = numStr.split('.'), wholePart = _a[0], decimalPart = _a[1];
    var numValue = parseInt(wholePart, 10);
    var wordResult = '';
    var unitIndex = 0;
    while (numValue > 0) {
        var chunk = numValue % 1000;
        if (chunk) {
            wordResult = convertHundreds(chunk) + (units[unitIndex] ? " " + units[unitIndex] : "") + " " + wordResult;
        }
        numValue = Math.floor(numValue / 1000);
        unitIndex++;
    }
    wordResult = wordResult.trim();
    if (decimalPart && parseInt(decimalPart) > 0) {
        wordResult += " AND ".concat(convertHundreds(parseInt(decimalPart)), " PAISA");
    }
    return wordResult + " ONLY";
};
var now = new Date();
// Format the date (e.g., "Friday, January 24, 2025")
export var formattedDate = now.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: '2-digit'
});
export var formattedTime = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
});
export var CustomerVoiceColumns = [{
        header: "S. No.",
        field: "srNo"
    }, {
        header: "Source",
        field: "source"
    }, {
        header: "Concern Reported by Customer",
        field: "ComplaintName"
    },
    // { header: "SA observations", field: "ObservationName" },
    {
        header: "SA Observations",
        field: "Remarks"
    }, {
        header: "Action Taken",
        field: "ActionTakenName"
    }, {
        header: "Est. Part Amt.",
        field: "PartPrice"
    }, {
        header: "Est. Lab Amt.",
        field: "LabourPrice"
    }, {
        header: "Total Amt.",
        field: "TotalPrice"
    }];
export var PartLabourColumns = [{
        header: "S. No.",
        field: "srNo"
    }, {
        header: "Section",
        field: "partSource"
    }, {
        header: "Part details ",
        field: "partName"
    }, {
        header: "Qty",
        field: "partQuantity"
    }, {
        header: "Amount",
        field: "partAmount"
    }, {
        header: "",
        field: ""
    }, {
        header: "S. No.",
        field: "srNo"
    }, {
        header: "Section",
        field: "labourSource"
    }, {
        header: "Service details",
        field: "labourName"
    }, {
        header: "Qty",
        field: "labourQuantity"
    }, {
        header: "Amount",
        field: "labourAmount"
    }];
export var PartColumns = [{
        header: "S. No.",
        field: "srNo"
    }, {
        header: "Section",
        field: "partSource"
    }, {
        header: "Part Details ",
        field: "partName"
    }, {
        header: "Qty",
        field: "partQuantity"
    }, {
        header: "Amount",
        field: "partAmount"
    }];
export var LabourColumns = [{
        header: "S. No.",
        field: "srNo"
    }, {
        header: "Section",
        field: "labourSource"
    }, {
        header: "Service Details",
        field: "labourName"
    }, {
        header: "Units",
        field: "labourQuantity"
    }, {
        header: "Amount",
        field: "labourAmount"
    }];
export var last2VisitColumns = [{
        header: "Date",
        field: "DocDate"
    }, {
        header: "KMs",
        field: "UsageReading"
    }, {
        header: "Branch",
        field: "BranchName"
    }, {
        header: "Service Type",
        field: "JobType"
    }, {
        header: "Technician",
        field: "MechanicName"
    }];
export var estimationColumns = [{
        header: "Total Part Amt.",
        field: "TotalPartAmount"
    }, {
        header: "Total Labour Amt.",
        field: "TotalLabourAmount"
    }, {
        header: "Total Amt.",
        field: "PartAndLabourTotal"
    }, {
        header: "Delivery Details",
        field: "EstimateDeliveryDate"
    }];
export var baseLeftItems = [{
        name: 'Petrol Tank'
    }, {
        name: 'Side indicator front'
    }, {
        name: 'Side indicator rear'
    }, {
        name: 'Seat cover'
    }, {
        name: 'Rear view mirror'
    }, {
        name: 'Tail light'
    }, {
        name: 'Hand lever'
    }, {
        name: 'Rear Mudguard'
    }];
export var baseRightItems = [{
        name: 'Rear tyre'
    }, {
        name: 'Silencer'
    }, {
        name: 'Chain'
    }, {
        name: 'Front Mudguard'
    }, {
        name: 'Rear Mudguard'
    }, {
        name: 'Front Mudguard'
    }, {
        name: 'Head light'
    }, {
        name: 'Front tyre'
    }];
export var formatAddressMultiline = function (addressData) {
    var Address1 = addressData.Address1, Address2 = addressData.Address2, CityName = addressData.CityName, StateName = addressData.StateName, Zip = addressData.Zip, CountryName = addressData.CountryName;
    var firstLine = [Address1, Address2].filter(Boolean).join(', ');
    var secondLine = [CityName, StateName, Zip, CountryName].filter(Boolean).join(', ');
    return "".concat(firstLine, "\n").concat(secondLine);
};
export var truncateAddress = function (address) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
    if ((address === null || address === void 0 ? void 0 : address.length) <= maxLength)
        return address;
    return (address === null || address === void 0 ? void 0 : address.slice(0, maxLength - 3).trimEnd()) + '...';
};
export var convertImageUrlToBase64 = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response, contentType, blob_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, fetch(url)];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch image: ".concat(response.status, " ").concat(response.statusText));
                }
                contentType = response.headers.get("Content-Type");
                if (!contentType || !contentType.startsWith("image/")) {
                    throw new Error("Invalid content-type: ".concat(contentType));
                }
                return [4 /*yield*/, response.blob()];
            case 2:
                blob_1 = _a.sent();
                return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            resolve(reader.result);
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob_1);
                    })];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                error_1 = _a.sent();
                console.error("Image to base64 failed:", error_1);
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); };
export var extractFormattedAdditionalLabours = function (additionalJobs) {
    var allLabours = [];
    var labours = (additionalJobs === null || additionalJobs === void 0 ? void 0 : additionalJobs.Labour) || [];
    labours.forEach(function (labour) {
        var price = (labour === null || labour === void 0 ? void 0 : labour.Price) || {};
        var taxes = (price === null || price === void 0 ? void 0 : price.Taxes) || [];
        var SGST = taxes.find(function (tax) { return tax.TaxComponentName === "SGST" || tax.TaxComponentName === "UTGST"; });
        var CGST = taxes.find(function (tax) { return tax.TaxComponentName === "CGST"; });
        allLabours.push({
            srNo: allLabours.length + 1,
            labourCodeName: "".concat(labour === null || labour === void 0 ? void 0 : labour.LabourName, " (").concat(labour === null || labour === void 0 ? void 0 : labour.LabourCode, ")"),
            Description: (labour === null || labour === void 0 ? void 0 : labour.Description) || '',
            HSNSACCode: (labour === null || labour === void 0 ? void 0 : labour.HSNSACCode) || (price === null || price === void 0 ? void 0 : price.HSNSACCode) || '',
            Rate: ((price === null || price === void 0 ? void 0 : price.Rate) || 0).toFixed(2),
            Quantity: ((labour === null || labour === void 0 ? void 0 : labour.Quantity) || 0).toFixed(2),
            UnitOfMeasurementName: (labour === null || labour === void 0 ? void 0 : labour.UnitOfMeasurementName) || '',
            TotaldiscountAmount: 0..toFixed(2),
            TaxableAmount: ((price === null || price === void 0 ? void 0 : price.TaxableAmount) || 0).toFixed(2),
            SGSTPercentage: ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage) || 0).toFixed(2),
            SGSTAmount: ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount) || 0).toFixed(2),
            CGSTPercentage: ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentPercentage) || 0).toFixed(2),
            CGSTAmount: ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentAmount) || 0).toFixed(2),
            Amount: ((price === null || price === void 0 ? void 0 : price.Amount) || 0).toFixed(2)
        });
    });
    return allLabours;
};
export var extractFormattedFlatParts = function (partsArray) {
    console.log('partsArray', partsArray);
    var allParts = [];
    partsArray === null || partsArray === void 0 || partsArray.forEach(function (part) {
        var price = (part === null || part === void 0 ? void 0 : part.Price) || {};
        var taxes = (price === null || price === void 0 ? void 0 : price.Taxes) || [];
        var SGST = taxes.find(function (tax) { return tax.TaxComponentName === "SGST" || tax.TaxComponentName === "UTGST"; });
        var CGST = taxes.find(function (tax) { return tax.TaxComponentName === "CGST"; });
        allParts.push({
            partCodeName: "".concat(part === null || part === void 0 ? void 0 : part.PartName, " (").concat(part === null || part === void 0 ? void 0 : part.PartCode, ")"),
            HSNCode: (part === null || part === void 0 ? void 0 : part.HSNCode) || (price === null || price === void 0 ? void 0 : price.HSNSACCode) || "",
            Rate: ((price === null || price === void 0 ? void 0 : price.Rate) || 0).toFixed(2),
            Quantity: ((part === null || part === void 0 ? void 0 : part.Quantity) || 0).toFixed(2),
            UnitOfMeasurementName: "",
            TotaldiscountAmount: 0..toFixed(2),
            TaxableAmount: ((price === null || price === void 0 ? void 0 : price.TaxableAmount) || 0).toFixed(2),
            SGSTPercentage: ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage) || 0).toFixed(2),
            SGSTAmount: ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount) || 0).toFixed(2),
            CGSTPercentage: ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentPercentage) || 0).toFixed(2),
            CGSTAmount: ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentAmount) || 0).toFixed(2),
            Amount: ((price === null || price === void 0 ? void 0 : price.Amount) || 0).toFixed(2)
        });
    });
    return allParts;
};
export var extractFormattedPeriodicLabours = function (labours) {
    var allLabours = [];
    labours === null || labours === void 0 || labours.forEach(function (labour) {
        var price = (labour === null || labour === void 0 ? void 0 : labour.Price) || {};
        var taxes = (price === null || price === void 0 ? void 0 : price.Taxes) || [];
        var SGST = taxes.find(function (tax) { return tax.TaxComponentName === "SGST" || tax.TaxComponentName === "UTGST"; });
        var CGST = taxes.find(function (tax) { return tax.TaxComponentName === "CGST"; });
        var IGST = taxes.find(function (tax) { return tax.TaxComponentName === "IGST"; });
        var isIGST = !!IGST;
        allLabours.push({
            labourCodeName: "".concat((labour === null || labour === void 0 ? void 0 : labour.LabourName) || "", " (").concat((labour === null || labour === void 0 ? void 0 : labour.LabourCode) || "", ")"),
            Description: (labour === null || labour === void 0 ? void 0 : labour.Description) || "",
            HSNSACCode: (labour === null || labour === void 0 ? void 0 : labour.HSNSACCode) || (price === null || price === void 0 ? void 0 : price.HSNSACCode) || "",
            Rate: ((price === null || price === void 0 ? void 0 : price.Rate) || 0).toFixed(2),
            Quantity: ((labour === null || labour === void 0 ? void 0 : labour.Quantity) || 0).toFixed(2),
            UnitOfMeasurementName: "",
            TotaldiscountAmount: 0..toFixed(2),
            TaxableAmount: ((price === null || price === void 0 ? void 0 : price.TaxableAmount) || 0).toFixed(2),
            SGSTPercentage: isIGST ? "0.00" : ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage) || 0).toFixed(2),
            SGSTAmount: isIGST ? "0.00" : ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount) || 0).toFixed(2),
            CGSTPercentage: isIGST ? "0.00" : ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentPercentage) || 0).toFixed(2),
            CGSTAmount: isIGST ? "0.00" : ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentAmount) || 0).toFixed(2),
            Amount: ((price === null || price === void 0 ? void 0 : price.Amount) || 0).toFixed(2)
        });
    });
    return allLabours;
};
export var loadBase64FromImportedImage = function (imageUrl) {
    return fetch(imageUrl).then(function (res) { return res.blob(); }).then(function (blob) { return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result); };
        reader.onerror = function () { return reject('Error reading blob'); };
        reader.readAsDataURL(blob);
    }); });
};
export var getLogoByChannel = function (channelName) {
    return logoMap[channelName] || BajajLogo;
};
export var getFinalInspectorName = function (data) {
    var _ref;
    var _a = (data === null || data === void 0 ? void 0 : data.FinalInspectorPerson) || {}, GivenName = _a.GivenName, FamilyName = _a.FamilyName;
    return (_ref = [GivenName, FamilyName]) === null || _ref === void 0 ? void 0 : _ref.filter(Boolean).join(' ');
};
export var printFeature = {
    DisplayName: "Print",
    FeatureAccesses: [],
    FeatureId: "2f824668-4ce6-4cc6-b20f-45345345340848773b7161",
    MenuId: "46562970-3389-4448-8081-5d734534eead8afce",
    ModuleId: "ed764a60-3ef6-4380-b249-8d3454345e3500463f",
    Name: "Print",
    id: "2f824668-4ce6-4cc6-3645863345435-0848773b7161"
};
export var getLabourColumnsAndHead = function (taxMode) {
    var baseColumns = [{
            header: "Sr. No.",
            field: "srNo"
        }, {
            header: "Labour Code & Labour Name ",
            field: "labourCodeName"
        }, {
            header: "Description",
            field: "Description"
        }, {
            header: "SAC",
            field: "HSNSACCode"
        }, {
            header: "RATE",
            field: "Rate"
        }, {
            header: "Units",
            field: "Quantity"
        },
        // { header: "UOM", field: "UnitOfMeasurementName" },
        {
            header: "Discount (%)",
            field: "discountPercentage"
        }, {
            header: "Discount (₹)",
            field: "discountAmount"
        }, {
            header: "Taxable Amount",
            field: "TaxableAmount"
        }];
    var taxColumns = [];
    if (taxMode === 'SGST_CGST') {
        taxColumns.push({
            header: "SGST/UTGST(%)",
            field: "SGSTPercentage"
        }, {
            header: "SGST/UTGST(₹)",
            field: "SGSTAmount"
        }, {
            header: "CGST (%)",
            field: "CGSTPercentage"
        }, {
            header: "CGST (₹)",
            field: "CGSTAmount"
        });
    }
    else if (taxMode === 'IGST') {
        taxColumns.push({
            header: "IGST (%)",
            field: "IGSTPercentage"
        }, {
            header: "IGST (₹)",
            field: "IGSTAmount"
        });
    }
    var finalColumns = __spreadArray(__spreadArray(__spreadArray([], baseColumns, true), taxColumns, true), [{
            header: "AMOUNT",
            field: "Amount"
        }], false);
    var groupedHeadRow1 = [{
            content: 'Sr. No.',
            rowSpan: 2
        }, {
            content: 'Labour Code & Labour Name',
            rowSpan: 2
        }, {
            content: 'Description',
            rowSpan: 2
        }, {
            content: 'SAC',
            rowSpan: 2
        }, {
            content: 'Rate',
            rowSpan: 2
        }, {
            content: 'Units',
            rowSpan: 2
        },
        // { content: 'UOM', rowSpan: 2 },
        {
            content: 'Discount',
            colSpan: 2,
            styles: {
                halign: 'left'
            }
        }, {
            content: 'Taxable Amount',
            rowSpan: 2
        }];
    var groupedHeadRow2 = [{
            content: '%',
            styles: {
                halign: 'left',
                fontStyle: 'bold',
                cellWidth: 10
            }
        }, {
            content: '₹',
            styles: {
                fonts: 'Roboto',
                halign: 'left',
                fontStyle: 'normal',
                cellWidth: 10
            }
        }];
    if (taxMode === 'SGST_CGST') {
        groupedHeadRow1.push({
            content: 'SGST/UTGST',
            colSpan: 2,
            styles: {
                halign: 'left'
            }
        }, {
            content: 'CGST',
            colSpan: 2,
            styles: {
                halign: 'left'
            }
        });
        groupedHeadRow2.push({
            content: '%',
            styles: {
                halign: 'left',
                fontStyle: 'bold'
            }
        }, {
            content: '₹',
            styles: {
                fonts: 'Roboto',
                halign: 'left',
                fontStyle: 'normal'
            }
        }, {
            content: '%',
            styles: {
                halign: 'left',
                fontStyle: 'bold'
            }
        }, {
            content: '₹',
            styles: {
                fonts: 'Roboto',
                halign: 'left',
                fontStyle: 'normal'
            }
        });
    }
    else if (taxMode === 'IGST') {
        groupedHeadRow1.push({
            content: 'IGST',
            colSpan: 2,
            styles: {
                fonts: 'Roboto',
                fontStyle: 'bold',
                halign: 'left'
            }
        });
        groupedHeadRow2.push({
            content: '%',
            styles: {
                halign: 'left',
                fontStyle: 'bold'
            }
        }, {
            content: '₹',
            styles: {
                fonts: 'Roboto',
                halign: 'left',
                fontStyle: 'normal'
            }
        });
    }
    groupedHeadRow1.push({
        content: 'Amount',
        rowSpan: 2
    });
    return {
        labourColumns: finalColumns,
        labourGroupedHead: [groupedHeadRow1, groupedHeadRow2]
    };
};
// export const getPartsColumnsAndHead = (taxMode: any) => {
//   const commonColumns = [
//     { header: "Sr. No.", field: "srNo" },
//     { header: "Part Code & Name ", field: "partCodeName" },
//     { header: "HSN", field: "HSNCode" },
//     { header: "RATE", field: "Rate" },
//     { header: "Qty", field: "Quantity" },
//     { header: "UOM", field: "UnitOfMeasurementName" },
//     { header: 'Discount (%)', field: 'discountPercentage' },
//     { header: 'Discount (₹)', field: 'discountAmount' },
//     { header: "Taxable Amount", field: "TaxableAmount" },
//   ];
//   const groupedHeadBase = [
//     [
//       { content: 'Sr. No.', rowSpan: 2 },
//       { content: 'Part Code & Part Name', rowSpan: 2 },
//       { content: 'HSN', rowSpan: 2 },
//       { content: 'Rate', rowSpan: 2 },
//       { content: 'Qty', rowSpan: 2 },
//       { content: 'UOM', rowSpan: 2 },
//       { content: 'Discount', colSpan: 2, styles: { halign: 'left' } },
//       { content: 'Taxable Amount', rowSpan: 2 },
//     ],
//     [
//       { content: '%', styles: { fontStyle: 'bold', cellWidth: 10 } },
//       { content: '₹', styles: { fonts: 'Roboto',  fontStyle: 'normal', cellWidth: 10 } },
//     ]
//   ];
//   if (taxMode === 'IGST') {
//     return {
//       partsColumns: [
//         ...commonColumns,
//         { header: "IGST (%)", field: "IGSTPercentage" },
//         { header: "IGST (₹)", field: "IGSTAmount" },
//         { header: "AMOUNT", field: "Amount" }
//       ],
//       partGroupedHead: [
//         [
//           ...groupedHeadBase[0],
//           { content: 'IGST', colSpan: 2, styles: { halign: 'left' } },
//           { content: 'Amount', rowSpan: 2 }
//         ],
//         [
//           ...groupedHeadBase[1],
//           { content: '%', styles: { halign: 'left', fontStyle: 'bold' } },
//           { content: '₹', styles: { fonts: 'Roboto', halign: 'left' } },
//         ]
//       ]
//     };
//   } else {
//     return {
//       partsColumns: [
//         ...commonColumns,
//         { header: "SGST/UTGST(%)", field: "SGSTPercentage" },
//         { header: "SGST/UTGST(₹)", field: "SGSTAmount" },
//         { header: "CGST (%)", field: "CGSTPercentage" },
//         { header: "CGST (₹)", field: "CGSTAmount" },
//         { header: "AMOUNT", field: "Amount" }
//       ],
//       partGroupedHead: [
//         [
//           ...groupedHeadBase[0],
//           { content: 'SGST/UTGST', colSpan: 2, styles: { halign: 'left' } },
//           { content: 'CGST', colSpan: 2, styles: { halign: 'left' } },
//           { content: 'Amount', rowSpan: 2 }
//         ],
//         [
//           ...groupedHeadBase[1],
//           { content: '%', styles: { halign: 'left' } },
//           { content: '₹', styles: { halign: 'left' } },
//           { content: '%', styles: { halign: 'left' } },
//           { content: '₹', styles: { halign: 'left' } },
//         ]
//       ]
//     };
//   }
// };
export var getPartsColumnsAndHead = function (taxMode) {
    var commonColumns = [{
            header: "Sr. No.",
            field: "srNo"
        }, {
            header: "Part Code & Name ",
            field: "partCodeName"
        }, {
            header: "HSN",
            field: "HSNCode"
        }, {
            header: "RATE",
            field: "Rate"
        }, {
            header: "Qty",
            field: "Quantity"
        }, {
            header: "UOM",
            field: "UnitOfMeasurementName"
        }, {
            header: "Discount (%)",
            field: "discountPercentage"
        }, {
            header: "Discount (₹)",
            field: "discountAmount"
        }, {
            header: "Taxable Amount",
            field: "TaxableAmount"
        }];
    var groupedHeadBase = [[{
                content: "Sr. No.",
                rowSpan: 2
            }, {
                content: "Part Code & Part Name",
                rowSpan: 2
            }, {
                content: "HSN",
                rowSpan: 2
            }, {
                content: "Rate",
                rowSpan: 2
            }, {
                content: "Qty",
                rowSpan: 2
            }, {
                content: "UOM",
                rowSpan: 2
            }, {
                content: "Discount",
                colSpan: 2,
                styles: {
                    halign: "left"
                }
            }, {
                content: "Taxable Amount",
                rowSpan: 2
            }], [{
                content: "%",
                styles: {
                    fontStyle: "bold",
                    cellWidth: 10
                }
            }, {
                content: "₹",
                styles: {
                    fonts: "Roboto",
                    fontStyle: "normal",
                    cellWidth: 10
                }
            }]];
    if (taxMode === "IGST") {
        return {
            partsColumns: __spreadArray(__spreadArray([], commonColumns, true), [{
                    header: "IGST (%)",
                    field: "IGSTPercentage"
                }, {
                    header: "IGST (₹)",
                    field: "IGSTAmount"
                }, {
                    header: "AMOUNT",
                    field: "Amount"
                }], false),
            partGroupedHead: [__spreadArray(__spreadArray([], groupedHeadBase[0], true), [{
                        content: "IGST",
                        colSpan: 2,
                        styles: {
                            halign: "left"
                        }
                    }, {
                        content: "Amount",
                        rowSpan: 2
                    }], false), __spreadArray(__spreadArray([], groupedHeadBase[1], true), [{
                        content: "%",
                        styles: {
                            halign: "left",
                            fontStyle: "bold"
                        }
                    }, {
                        content: "₹",
                        styles: {
                            fonts: "Roboto",
                            halign: "left"
                        }
                    }], false)]
        };
    }
    else if (taxMode === "SGST_CGST") {
        return {
            partsColumns: __spreadArray(__spreadArray([], commonColumns, true), [{
                    header: "SGST/UTGST(%)",
                    field: "SGSTPercentage"
                }, {
                    header: "SGST/UTGST(₹)",
                    field: "SGSTAmount"
                }, {
                    header: "CGST (%)",
                    field: "CGSTPercentage"
                }, {
                    header: "CGST (₹)",
                    field: "CGSTAmount"
                }, {
                    header: "AMOUNT",
                    field: "Amount"
                }], false),
            partGroupedHead: [__spreadArray(__spreadArray([], groupedHeadBase[0], true), [{
                        content: "SGST/UTGST",
                        colSpan: 2,
                        styles: {
                            halign: "left"
                        }
                    }, {
                        content: "CGST",
                        colSpan: 2,
                        styles: {
                            halign: "left"
                        }
                    }, {
                        content: "Amount",
                        rowSpan: 2
                    }], false), __spreadArray(__spreadArray([], groupedHeadBase[1], true), [{
                        content: "%",
                        styles: {
                            halign: "left"
                        }
                    }, {
                        content: "₹",
                        styles: {
                            halign: "left"
                        }
                    }, {
                        content: "%",
                        styles: {
                            halign: "left"
                        }
                    }, {
                        content: "₹",
                        styles: {
                            halign: "left"
                        }
                    }], false)]
        };
    }
    else {
        return {
            partsColumns: __spreadArray(__spreadArray([], commonColumns, true), [{
                    header: "AMOUNT",
                    field: "Amount"
                }], false),
            partGroupedHead: [__spreadArray(__spreadArray([], groupedHeadBase[0], true), [{
                        content: "Amount",
                        rowSpan: 2
                    }], false), __spreadArray([], groupedHeadBase[1], true)]
        };
    }
};
export function truncateTextWithLines(doc, text, maxWidth, maxLines) {
    if (!text)
        return '';
    var lines = doc.splitTextToSize(text, maxWidth);
    if (lines.length > maxLines) {
        lines = lines.slice(0, maxLines);
        if (!lines[maxLines - 1].endsWith('...')) {
            var line = lines[maxLines - 1];
            if (line.length > 3) {
                lines[maxLines - 1] = line.substring(0, line.length - 3) + '...';
            }
            else {
                lines[maxLines - 1] = line + '...';
            }
        }
    }
    return lines.join('\n');
}
export var getLatestContractByKey = function (key, settings, contracts) {
    var _valueString$split;
    var entry = settings === null || settings === void 0 ? void 0 : settings.find(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) === key; });
    var valueString = (entry === null || entry === void 0 ? void 0 : entry.Value) || "";
    var idArray = valueString === null || valueString === void 0 || (_valueString$split = valueString.split(",")) === null || _valueString$split === void 0 ? void 0 : _valueString$split.map(function (v) { return v === null || v === void 0 ? void 0 : v.trim(); });
    var filteredContracts = contracts === null || contracts === void 0 ? void 0 : contracts.filter(function (contract) { return idArray === null || idArray === void 0 ? void 0 : idArray.includes(contract === null || contract === void 0 ? void 0 : contract.ServiceContractId); });
    var latestContract = filteredContracts.reduce(function (latest, current) {
        var latestDate = new Date((latest === null || latest === void 0 ? void 0 : latest.EffectiveTo) || 0).getTime();
        var currentDate = new Date((current === null || current === void 0 ? void 0 : current.EffectiveTo) || 0).getTime();
        return currentDate > latestDate ? current : latest;
    }, null);
    return latestContract;
};
